import INFTCollections from '../../models/INFTCollections'
import HuskyNFTCard from '../../nftFormats/HuskyNFT/Card/HuskyNFTCard'
import HuskyNFTDetail from '../../nftFormats/HuskyNFT/Detail/HuskyNFTDetail'
import HuskyNFTActivtyDetail from '../../nftFormats/HuskyNFT/Activity/HuskyNFTActivtyDetail'
import HuskyNFTLogo from '../../../../assets/nft-logo/HuskyNFT.jpg'

export const HuskyNFTData: INFTCollections[] = [
  {
    id: 'Husky3DNFT',
    tokenAddress: '0xf0229b39a278ce003f852b1965fdb624602496ca',
    name: 'Husky 3D NFT',
    cardFormat: HuskyNFTCard,
    detailFormat: HuskyNFTDetail,
    activityFormat: HuskyNFTActivtyDetail,
    category: 1,
    creatorAddress: '0x9eeaa0acaa866797845b6545cb4e8cd17851edc9',
    logo: HuskyNFTLogo,
    website: 'https://www.husky.space/collections/nft',
    twitter: 'AvaxHusky',
    telegram: 'https://t.me/HuskyAvalanche',
    discord: 'https://discord.com/invite/VHv8GHmhSt'
  }
]

export const HuskyNFTCategoryData = {
  [HuskyNFTData[0].tokenAddress.toLowerCase()]: HuskyNFTData[0].category
}
